import { contentType } from '@/utils/Page/constant';
import FileType from '@/components/FileType';
import s from './style.module.scss';
import { Display } from '../../Display/Display';
import { useEffect, useState } from 'react';
const FileDetail = (props) => {
    const [curData, setCurData] = useState({});
    useEffect(() => {
        if (props.data) {
            console.log(props.data);
            setCurData(props.data);
        }
    }, [props.data]);
    return (
        <div className={s['file-detail']}>
            <Display show={curData?.type === contentType.retrieval}>
                <FileType showType={false} fileName={curData?.title}></FileType>
            </Display>
            <Display show={curData?.type === contentType.web_search}>
                <img src={curData?.icon} alt="" />
            </Display>
            {curData?.title}
        </div>
    );
};
export default FileDetail;
